/**
 * Daily Belts buy box — qty packs + one swatch row with belt chips.
 * Replaces cloned dual color pickers (theme.js block is no-op when this runs).
 */
(function () {
  function boot() {
    var formRoot = document.querySelector('[data-db-color-picker], Belt-varinat-form, belt-varinat-form');
    if (!formRoot || formRoot.dataset.dbChipsBound === '1') return;
    formRoot.dataset.dbChipsBound = '1';

    var chipsEl = formRoot.querySelector('[data-db-color-chips]');
    var hintEl = formRoot.querySelector('[data-db-color-hint]');
    var errorEl = formRoot.querySelector('.color_error');
    var soldOutEl = formRoot.querySelector('.sold_out_color');
    var swatchForms = Array.prototype.slice.call(formRoot.querySelectorAll('.belt_varinat_form'));
    var qtyBlocks = Array.prototype.slice.call(document.querySelectorAll('.custom_variant_inner'));

    if (!chipsEl || !swatchForms.length || !qtyBlocks.length) return;

    var quantity = 1;
    var activeSlot = 0;
    /** @type {Array<{id:string,title:string,qty:number}|null>} */
    var selections = [];

    function clickFirstThumbnail() {
      var first = document.querySelector('.product-gallery__thumbnail-list .product-gallery__thumbnail');
      if (first) first.click();
    }

    function parseQty(block) {
      var el = block.querySelector('[data-show-quanity]');
      return parseInt(el && el.dataset.showQuanity ? el.dataset.showQuanity : '1', 10) || 1;
    }

    function firstEmptySlot() {
      for (var i = 0; i < quantity; i++) {
        if (!selections[i]) return i;
      }
      return Math.max(0, quantity - 1);
    }

    function setQuantity(q) {
      var prevQty = quantity;
      var nextQty = Math.max(1, q | 0);

      /*
        Keep colors for belts that still exist.
        Increasing (e.g. 3→4): preserve 1..3, leave new slot empty, focus that chip.
        Decreasing (e.g. 4→2): drop trailing picks (last colors removed).
      */
      var next = [];
      for (var i = 0; i < nextQty; i++) {
        next[i] = selections[i] || null;
      }
      // Trailing selections beyond nextQty are discarded intentionally
      selections = next;
      quantity = nextQty;

      if (nextQty > prevQty) {
        // Focus first empty belt (new slot after filled ones)
        activeSlot = firstEmptySlot();
      } else if (nextQty < prevQty) {
        // After removing last pick(s), land on last remaining chip
        activeSlot = Math.max(0, nextQty - 1);
      } else if (activeSlot >= nextQty) {
        activeSlot = Math.max(0, nextQty - 1);
      }

      renderChips();
      syncSwatches();
      updateHint();
      hideErrors();
    }

    function hideErrors() {
      if (errorEl) errorEl.style.display = 'none';
      if (soldOutEl) soldOutEl.style.display = 'none';
    }

    function updateHint() {
      if (!hintEl) return;
      if (quantity <= 1) {
        hintEl.textContent = selections[0] ? '· ' + selections[0].title : '· Choose a color';
      } else {
        var filled = selections.filter(Boolean).length;
        hintEl.textContent = '· ' + filled + ' of ' + quantity + ' selected';
      }
    }

    function renderChips() {
      chipsEl.innerHTML = '';
      chipsEl.hidden = false;
      formRoot.classList.toggle('is-multi', quantity > 1);
      formRoot.classList.toggle('is-qty-2', quantity === 2);
      formRoot.classList.toggle('is-qty-3', quantity === 3);
      formRoot.classList.toggle('is-qty-4', quantity === 4);
      formRoot.setAttribute('data-qty', String(quantity));
      chipsEl.dataset.chipCount = String(quantity);
      chipsEl.setAttribute('data-chip-count', String(quantity));

      for (var i = 0; i < quantity; i++) {
        var sel = selections[i];
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className =
          'db-color-chip' +
          (i === activeSlot ? ' is-active' : '') +
          (sel ? ' is-filled' : '');
        chip.setAttribute('aria-pressed', i === activeSlot ? 'true' : 'false');
        chip.dataset.slot = String(i);

        var swatchDot = '';
        if (sel) {
          var match = swatchForms.find(function (f) {
            var v = f.querySelector('.belt_variant_custom');
            return v && v.dataset.variantId === sel.id;
          });
          var bg = match && match.querySelector('.belt_variant_custom');
          if (bg && bg.getAttribute('style')) {
            swatchDot =
              '<span class="db-color-chip__dot" style="' +
              bg.getAttribute('style') +
              '"></span>';
          }
        }

        chip.innerHTML =
          swatchDot +
          '<span class="db-color-chip__text">' +
          '<span class="db-color-chip__label">Belt ' +
          (i + 1) +
          '</span>' +
          '<span class="db-color-chip__value">' +
          (sel ? escapeHtml(sel.title) : 'Choose color') +
          '</span></span>';

        chip.addEventListener('click', onChipClick);
        chipsEl.appendChild(chip);
      }
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function onChipClick(e) {
      var btn = e.currentTarget;
      activeSlot = parseInt(btn.dataset.slot, 10) || 0;
      renderChips();
      syncSwatches();
    }

    function syncSwatches() {
      var active = selections[activeSlot];
      swatchForms.forEach(function (form) {
        var custom = form.querySelector('.belt_variant_custom');
        var id = custom && custom.dataset.variantId;
        var inv = parseInt((custom && custom.dataset.varinatQuantity) || '0', 10);
        form.classList.toggle('belt_varinat_form_select', !!(active && active.id === id));
        if (inv <= 0) {
          form.classList.add('variant_disabled');
          form.style.opacity = '0.5';
        }
      });
    }

    function selectVariantForActiveSlot(form) {
      var custom = form.querySelector('.belt_variant_custom');
      if (!custom) return;

      var id = custom.dataset.variantId;
      var title = custom.dataset.variantTitle || '';
      var inv = parseInt(custom.dataset.varinatQuantity || '0', 10);

      hideErrors();

      if (inv <= 0) {
        if (soldOutEl) {
          var soldColor = soldOutEl.querySelector('.sold_color');
          if (soldColor) soldColor.textContent = title;
          soldOutEl.style.display = 'inline-flex';
          soldOutEl.style.color = 'red';
        }
        return;
      }

      selections[activeSlot] = { id: id, title: title, qty: inv };

      /* Advance to next empty slot if multi-pack */
      if (quantity > 1) {
        var nextEmpty = -1;
        for (var i = 0; i < quantity; i++) {
          var idx = (activeSlot + 1 + i) % quantity;
          if (!selections[idx]) {
            nextEmpty = idx;
            break;
          }
        }
        if (nextEmpty >= 0) activeSlot = nextEmpty;
      }

      renderChips();
      syncSwatches();
      updateHint();
      updateGallery(id);
    }

    function updateGallery(variantId) {
      var featuredMedia = window.variantMedia && window.variantMedia[variantId];
      if (featuredMedia && featuredMedia.position) {
        var thumbs = document.querySelectorAll(
          '.product-gallery__thumbnail-list .product-gallery__thumbnail'
        );
        var target = thumbs[featuredMedia.position - 1];
        if (target) target.click();
      }
      if (featuredMedia && featuredMedia.id) {
        var mediaToActivate = document.querySelector('[data-media-id="' + featuredMedia.id + '"]');
        if (mediaToActivate) {
          document
            .querySelectorAll(
              'product-gallery media-gallery media-image, product-gallery media-gallery .media'
            )
            .forEach(function (slide) {
              slide.removeAttribute('active');
            });
          mediaToActivate.setAttribute('active', '');
        }
      }
    }

    function validate(showErrors) {
      var ok = true;
      for (var i = 0; i < quantity; i++) {
        if (!selections[i] || !selections[i].id) {
          ok = false;
          break;
        }
        if (selections[i].qty <= 0) {
          ok = false;
          break;
        }
      }
      if (!ok && showErrors && errorEl) {
        errorEl.style.display = 'inline';
        errorEl.textContent =
          quantity > 1
            ? 'Please select a color for each belt'
            : 'Please select a color';
      }
      if (ok && errorEl) errorEl.style.display = 'none';
      return ok;
    }

    function getSelectedVariantIds() {
      return selections.filter(Boolean).map(function (s) {
        return s.id;
      });
    }

    function handleQtyClick(block) {
      clickFirstThumbnail();
      qtyBlocks.forEach(function (b) {
        b.classList.remove('custom_variant_inner_active');
      });
      block.classList.add('custom_variant_inner_active');

      var q = parseQty(block);
      /* Keep colors that still fit; clear extras */
      setQuantity(q);

      var salePriceEls = document.querySelectorAll('.variant-sale-price');
      var discountPrice = block.querySelector('.discount_price_gt');
      var originalPriceEls = document.querySelectorAll('.variant-original-price');

      salePriceEls.forEach(function (el) {
        if (q === 1) {
          el.style.display = 'none';
        } else if (discountPrice) {
          el.textContent = discountPrice.textContent.trim();
          el.style.display = 'inline';
        }
      });
      originalPriceEls.forEach(function (el) {
        if (q === 1) el.classList.remove('line-stroke');
        else el.classList.add('line-stroke');
      });
    }

    async function addToCartWithPopup(variantIds, showPopup) {
      for (var i = 0; i < variantIds.length; i++) {
        var variantId = variantIds[i];
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quantity: 1, id: variantId }),
        }).then(function (r) {
          return r.json();
        });

        if (showPopup) {
          await new Promise(function (resolve) {
            setTimeout(async function () {
              try {
                var sectionRes = await fetch(
                  '/variants/' + variantId + '?section_id=variant-added'
                );
                var sectionHTML = await sectionRes.text();
                document.dispatchEvent(
                  new CustomEvent('variant:add', {
                    detail: {
                      cart: { sections: { 'variant-added': sectionHTML } },
                      blockCartDrawerOpening: false,
                      addedVariants: variantIds,
                    },
                  })
                );
              } catch (err) {}
              resolve();
            }, i === 0 ? 200 : 100);
          });
        }
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      /* Reset selections after add */
      selections = selections.map(function () {
        return null;
      });
      activeSlot = 0;
      renderChips();
      syncSwatches();
      updateHint();
    }

    /* Bind swatches */
    swatchForms.forEach(function (form) {
      var custom = form.querySelector('.belt_variant_custom');
      var inv = parseInt((custom && custom.dataset.varinatQuantity) || '0', 10);
      if (inv <= 0) {
        form.classList.add('variant_disabled');
        form.style.opacity = '0.5';
      }
      form.addEventListener('click', function () {
        selectVariantForActiveSlot(form);
      });
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectVariantForActiveSlot(form);
        }
      });
    });

    /* Bind qty cards */
    qtyBlocks.forEach(function (block) {
      block.addEventListener('click', function () {
        handleQtyClick(block);
      });
    });

    /* ATC / Checkout — capture phase so we win over theme.js if both bound */
    document.querySelectorAll('.add_to_cart button').forEach(function (button) {
      button.addEventListener(
        'click',
        async function (e) {
          if (!validate(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          var ids = getSelectedVariantIds();
          if (ids.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            button.setAttribute('aria-busy', 'true');
            await addToCartWithPopup(ids, true);
            button.removeAttribute('aria-busy');
          }
        },
        true
      );
    });

    document.querySelectorAll('.checkout_button button').forEach(function (button) {
      button.addEventListener(
        'click',
        async function (e) {
          if (!validate(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          var ids = getSelectedVariantIds();
          if (ids.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            button.setAttribute('aria-busy', 'true');
            await addToCartWithPopup(ids, false);
            button.removeAttribute('aria-busy');
            window.location.href = '/checkout';
          }
        },
        true
      );
    });

    /* Default Most Popular (qty 2) */
    var defaultBlock =
      document.querySelector('.custom_variant_quantity2') ||
      document.querySelector('.custom_variant_inner_active') ||
      qtyBlocks[0];
    if (defaultBlock) handleQtyClick(defaultBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 0);
    });
  } else {
    setTimeout(boot, 0);
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-db-color-picker]').forEach(function (el) {
      delete el.dataset.dbChipsBound;
    });
    setTimeout(boot, 0);
  });
})();
